import { Route, RouteComponentProps } from 'react-router-dom';
import { TERMS_AND_CONDITIONS_MIGRATED_CHECK } from './routes';

import TermsMigratedLayout from '../layout/TermsMigrated/termsMigratedLayout';
import TermsConditionsMigratedCheck from '../views/TermsConditionsMigratedCheck/TermsConditionsMigratedCheck';

export const TermsMigratedRoutes = (props: RouteComponentProps) => {
  return (
    <TermsMigratedLayout {...props}>
      <Route
        exact
        path={TERMS_AND_CONDITIONS_MIGRATED_CHECK}
        render={() => <TermsConditionsMigratedCheck {...props} />}
      />
    </TermsMigratedLayout>
  );
};
